<template>
  <div style="min-width:900px;overflow-x:auto">
    <h2>Contacts</h2>
    <b-card header="Page help" header-bg-variant="primary" header-text-variant="light">
      <p class="card-text">
        From this page you can manage the council contacts for both internal 
        and external communications between Pan Essex reviewers. The 
        external/primary contact is the point of contact for all other 
        councils and if no one more specific is supplied for internal comms.<br/>
        <br/>
        You can have multiple contacts for any of the categories supplied.</p>
    </b-card>
    <loading :loading="isLoading">
      <error :error="error"/>
      <div v-if="page">
        <b-card header="Our contacts">
          <contact-table :contacts="page.OurContacts" :showactions="true"/>
          <b-list-group flush>
            <b-list-group-item>
              <new-contact @created="newContactAdded" />
            </b-list-group-item>
          </b-list-group>
        </b-card>

        <b-card header="Everyone else's contacts">
          <search :items="page.TheirContacts" :showatonce="5">
            <template #results="data">
              <contact-table :contacts="data.items"/>
            </template>
          </search>
        </b-card>
      </div>
    </loading>
  </div>
</template>

<script>
import Loading from '../components/Loading.vue'
import Error from '../components/Error.vue'
import Search from '../components/Search.vue'
import ContactTable from '../components/ContactTable.vue'
import NewContact from '../components/NewContact.vue'

export default {
  components: { Loading, Error, Search, ContactTable, NewContact },
  data() {
    return {
      isLoading: true,
      error: null,
      page: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      const { access_token } = this.$store.state.oidcStore;
      this.$reportingApi.renderPage('panessex', access_token, {
        pageName: 'Contacts',
      })
      .then(page => { this.page = page; this.isLoading = false; })
      .catch(e => { this.error = e.message; this.isLoading = false; });
    },
    newContactAdded() {
      this.fetchData();
    },
  },
};
</script>
